//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiClockTimeFourOutline } from '@mdi/js'

export default {
  setup() {
    const time = ref(null)
    const menu2 = ref(false)
    const modal2 = ref(false)

    return {
      time,
      menu2,
      modal2,
      icons: {
        mdiClockTimeFourOutline,
      },
    }
  },
}
